export default "__VITE_ASSET__c32e81d6__"